import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

const HeightSelect = ({ label, name, value, onChange, onBlur }) => {
  const { t, i18n } = useTranslation();

  // Translations for "feet" and "inches"
  const feetText = t("feet");
  const inchesText = t("inches");

  return (
    <FormControl fullWidth variant="outlined">
      {/* Added htmlFor and adjusted sx */}
      <InputLabel
        id={`${name}-label`}
        htmlFor={name} // Connects label to the select
        sx={{
          backgroundColor: 'white',
          px: 0.5,
          zIndex: 1,
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)',
            backgroundColor: 'white',
          }
        }}
      >
        {label}
      </InputLabel>

      <Select
        labelId={`${name}-label`}
        id={name}
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        displayEmpty
        inputProps={{
          style: { borderRadius: 0 },
          'aria-label': 'Height selection'
        }}
        sx={{
          // Fixed hover and focus styles
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
            transition: 'border-color 0.2s ease'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ff6b6b !important',
            borderWidth: '2px'
          },
        }}
      >
        {[...Array(61).keys()].map((idx) => {
          const num = idx + 36;
          const feet = Math.floor(num / 12);
          const inches = num % 12;
          return (
            <MenuItem key={num} value={`${feet} ${feetText}, ${inches} ${inchesText}`}>
              {feet} {feetText}, {inches} {inchesText}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default HeightSelect;